import { environment } from "@environments/environment";

export class User {
  accountId: number;
  accountName: string;
  canValidate: boolean;
  checkOutMs: any;
  connectEnabled: boolean;
  defaultLang: string;
  defaultRole: string;
  emails: Email[];
  phones: any[];
  room: any;
  singlePlaceId: any;
  title: string;
  isPasswordExpired: boolean;
  displayName: string;
  firstName: string;
  lastName: string;
  imageUrl: string;
  primaryEmail: string;
  primaryPhoneNumber: any;
  id: number;
  refId: string;

  constructor(dto: any) {
    this.accountId = dto.account_id ?? null;
    this.accountName = dto.account_name ?? "";
    this.canValidate = dto.can_validate ?? false;
    this.checkOutMs = dto.check_out_ms ?? null;
    this.connectEnabled = dto.connect_enabled ?? false;
    this.defaultLang = dto.default_lang ?? "";
    this.defaultRole = dto.default_role ?? "";
    this.emails = Array.isArray(dto.emails) ? dto.emails.map((e: any) => new Email(e)) : [];
    this.phones = dto.phones ?? [];
    this.room = dto.room ?? null;
    this.singlePlaceId = dto.single_place_id ?? null;
    this.title = dto.title ?? "";
    this.isPasswordExpired = dto.is_password_expired ?? false;
    this.displayName = dto.display_name ?? "";
    this.firstName = dto.first_name ?? "";
    this.lastName = dto.last_name ?? "";
    this.imageUrl = dto.image_url ?? "";
    this.primaryEmail = dto.primary_email ?? "";
    this.primaryPhoneNumber = dto.primary_phone_number ?? null;
    this.id = dto.id ?? 0;
    this.refId = dto.ref_id ?? "";
  }
}

export class Email {
  address: string;
  primary: boolean;
  type: string;
  verified: boolean;
  id: number;
  refId: string;

  constructor(dto: any) {
    this.address = dto.address ?? "";
    this.primary = dto.primary ?? false;
    this.type = dto.type ?? "";
    this.verified = dto.verified ?? false;
    this.id = dto.id ?? 0;
    this.refId = dto.refId ?? "";
  }
}

export class LoginRequest {
  username: string;
  password: string;
  client_id: string;
  client_secret: string;
  grant_type?: "password" | "refresh_token";
  scope?: "connect";

  constructor(
    username: string,
    password: string,
    grantType: "password" | "refresh_token" = "password",
  ) {
    this.username = username;
    this.password = password;
    this.client_id = environment.clientId;
    this.client_secret = environment.clientSecret;
    this.scope = "connect";
    this.grant_type = grantType;
  }
}

export interface LoginResponse {
  access_token: string;
  refresh_token: string;
  expires_in: number;
  token_type: string;
}

export interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  loading: boolean;
  error: string | null;
}
